<template>
  <AlertComponent v-if="content" v-bind="$attrs" :theme="theme">
    <span v-html="content"></span>
  </AlertComponent>
</template>

<script>
import { AlertComponent } from 'vue-elder-alert'

export default {
  props: ['value'],
  computed: {
    theme() {
      if (this.value && this.value.theme) return this.value.theme
      return this.$attrs.theme
    },
    contentRaw() {
      if (this.value && typeof this.value === 'string') return this.value
      if (this.value && this.value.content) return this.value.content
      return this.$attrs.label
    },
    content() {
      return this.contentRaw.replace(/\[(.+)\]\((.+)\)/g, '<a href="$2" target="_blank">$1</a>')
    },
  },
  components: {
    AlertComponent,
  },
}
</script>
